import React, { useEffect, useState } from 'react';
import { db } from '../firebase';
import { collection, onSnapshot, doc, updateDoc } from 'firebase/firestore';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, CircularProgress, Button, Chip } from '@mui/material';
import toast from 'react-hot-toast';

export const RidersPage = () => {
  const [riders, setRiders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onSnapshot(collection(db, 'users'), (snapshot) => {
      const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setRiders(data);
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  const suspendRider = async (uid) => {
    if (!window.confirm('Suspend this rider? They will not be able to request rides.')) return;
    try {
      await updateDoc(doc(db, 'users', uid), { suspended: true, suspendedAt: new Date() });
      toast.success('Rider suspended');
    } catch (err) {
      toast.error(err.message);
    }
  };

  const unsuspendRider = async (uid) => {
    if (!window.confirm('Unsuspend this rider?')) return;
    try {
      await updateDoc(doc(db, 'users', uid), { suspended: false, suspendedAt: null });
      toast.success('Rider unsuspended');
    } catch (err) {
      toast.error(err.message);
    }
  };

  if (loading) return <CircularProgress />;

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>User ID</TableCell>
            <TableCell>Email</TableCell>
            <TableCell>Name</TableCell>
            <TableCell>Phone</TableCell>
            <TableCell>Status</TableCell>
            <TableCell>Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {riders.map(rider => (
            <TableRow key={rider.id}>
              <TableCell>{rider.id.slice(-8)}</TableCell>
              <TableCell>{rider.email}</TableCell>
              <TableCell>{rider.name || '-'}</TableCell>
              <TableCell>{rider.phone || '-'}</TableCell>
              <TableCell><Chip label={rider.suspended ? 'Suspended' : 'Active'} color={rider.suspended ? 'error' : 'success'} size="small" /></TableCell>
              <TableCell>
                {rider.suspended ? (
                  <Button size="small" variant="outlined" onClick={() => unsuspendRider(rider.id)}>Unsuspend</Button>
                ) : (
                  <Button size="small" variant="outlined" color="error" onClick={() => suspendRider(rider.id)}>Suspend</Button>
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
